import axios from "axios";
import $ from "jquery-ajax";
import Crypto from "./utils/crypto";
import prefix from "./utils/prefixPath";

// var serverApiHost = "http://10.62.58.185:5987";
var key = "NxVetKey";
let serverApiHost = location.protocol + "//" + location.hostname;
let serverSDKHost = location.protocol + "//" + location.hostname;

const getApiServerHost = () => {
  // console.log("protocol", location.protocol, "hostname", location.hostname);
  // console.log("serverApiHost", serverApiHost);
  // console.log("serverSDKHost", serverSDKHost);
  return serverApiHost;
};
const getSDKServerHost = () => {
  return serverSDKHost;
};
const setApiServerHost = (host) => {
  serverApiHost = host;
};

if (
  location.hostname == "dev.nxvet.io" ||
  location.hostname == "node3.nxvet.io"
) {
  serverApiHost = "https://dev.nxvet.io";
  serverSDKHost = "https://dev.nxvet.io";
} else if (
  location.hostname == "nxvet.io" ||
  location.hostname == "www.nxvet.io" ||
  location.hostname == "node4.nxvet.io"
) {
  serverApiHost = "https://nxvet.io";
  serverSDKHost = "https://nxvet.io";
} else if (
  location.hostname == "s2.nxvet.io" ||
  location.hostname == "node5.nxvet.io"
) {
  serverApiHost = "https://s2.nxvet.io";
  serverSDKHost = "https://s2.nxvet.io";
} else if (
  location.hostname == "s3.nxvet.io" ||
  location.hostname == "node6.nxvet.io"
) {
  serverApiHost = "https://s3.nxvet.io";
  serverSDKHost = "https://s3.nxvet.io";
} else if (
  location.hostname == "s4.nxvet.io" ||
  location.hostname == "node7.nxvet.io"
) {
  serverApiHost = "https://s4.nxvet.io";
  serverSDKHost = "https://s4.nxvet.io";
} else if (
  location.hostname == "s4m.nxvet.io"
) {
  serverApiHost = "https://s4m.nxvet.io";
  serverSDKHost = "https://s4m.nxvet.io";
} else if (location.hostname == "s5.nxvet.io") {
  serverApiHost = "https://s5.nxvet.io";
  serverSDKHost = "https://s5.nxvet.io";
} else if (location.hostname == "s6.nxvet.io") {
  serverApiHost = "https://s6.nxvet.io";
  serverSDKHost = "https://s6.nxvet.io";
} else if (location.hostname == "s7.nxvet.io") {
  serverApiHost = "https://s7.nxvet.io";
  serverSDKHost = "https://s7.nxvet.io";
} else if (location.hostname == "s99.nxvet.io") {
  serverApiHost = "https://s99.nxvet.io";
  serverSDKHost = "https://s99.nxvet.io";
} else if (
  location.hostname == "nxvet-haproxy" ||
  location.hostname == "nxvet-web"
) {
  serverApiHost = "http://nxvet-erp:5987";
  serverSDKHost = "http://nxvet-api:5983";
} else if (location.hostname.indexOf("192.168") != -1) {
  serverApiHost = `http://${location.hostname}:5987`;
  serverSDKHost = `http://${location.hostname}:5983`;
} else {
  serverApiHost = "http://127.0.0.1:5987";
  serverSDKHost = "http://127.0.0.1:5983";
}

const ORDER_PROCESS = 0;
const ORDER_COMPLETE = 1;
const ORDER_PLACE = 2;

const switchCustomer = (customer_id, username, password) => {
  localStorage.setItem("CLINIC", customer_id);
  localStorage.setItem("LAST_USERNAME", Crypto.encrypt(username, key));
  localStorage.setItem("LAST_PASSWORD", Crypto.encrypt(password, key));
};
/**
 * Auth header
 */
const getAuthorization = () => {
  if (
    localStorage.getItem("LAST_USERNAME") &&
    localStorage.getItem("LAST_PASSWORD")
  ) {
    //downward compatibility old authenticate method
    const username = Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key);
    const password = Crypto.decrypt(localStorage.getItem("LAST_PASSWORD"), key);
    return "Basic " + btoa(username + ":" + password);
  } else if (localStorage.getItem("JWT")) {
    //use latest authenticate method
    return "Bearer " + localStorage.getItem("JWT");
  } else {
    return "";
  }
};

/**
 * 新增供應商
 * @param {Json}   supplierData
 * @param {String} supplierData.customID         customID
 * @param {String} [supplierData.type]           type
 * @param {String} supplierData.name             name
 * @param {String} [supplierData.gui]            gui
 * @param {String} supplierData.contactName      contactName
 * @param {String} supplierData.namecontactPhone contactPhone
 * @param {String} [supplierData.contactEmail]   contactEmail
 * @param {String} [supplierData.address]        address
 * @param {String} [supplierData.fax]            fax
 * @param {String} [supplierData.website]        website
 * @param {String} [supplierData.info]           info
 *
 * @returns {Promise}
 */
const createSupplier = ({
  customID,
  type,
  name,
  gui,
  contactName,
  contactPhone,
  contactEmail,
  address,
  fax,
  website,
  info,
  prods = [],
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    type,
    name,
    gui,
    contactName,
    contactPhone,
    contactEmail,
    address,
    fax,
    website,
    info,
    prods,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/supplier`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得供應商資訊
 * @param {String} supplierID      supplierID
 *
 * @returns {Promise}
 */
const getSupplierData = (supplierID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/supplier/${supplierID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新供應商資訊
 * @param {Json}   supplierData
 * @param {String} supplierData.supplierID      supplierID
 * @param {String} supplierData.customID        customID
 * @param {String} [supplierData.type]          type
 * @param {String} supplierData.name            name
 * @param {String} [supplierData.gui]           gui
 * @param {String} supplierData.contactName     contactName
 * @param {String} supplierData.contactPhone    contactPhone
 * @param {String} [supplierData.contactEmail]  contactEmail
 * @param {String} [supplierData.address]       address
 * @param {String} [supplierData.fax]           fax
 * @param {String} [supplierData.website]       website
 * @param {String} [supplierData.info]          info
 *
 * @param {Json}    supplierProds
 * @param {String}  supplierProds.prodID      productID
 * @param {String}  supplierProds.price       product price
 * @param {String}  supplierProds.moq         product moq
 *
 * @returns {Promise}
 */
const updateSupplierData = ({
  supplierID,
  customID,
  type,
  name,
  gui,
  contactName,
  contactPhone,
  contactEmail,
  address,
  fax,
  website,
  info,
  prods = [],
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customID,
    type,
    name,
    gui,
    contactName,
    contactPhone,
    contactEmail,
    address,
    fax,
    website,
    info,
    prods,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/supplier/${supplierID}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除供應商
 *
 * @returns {Promise}
 */
const deleteSupplier = (supplierID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/supplier/${supplierID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得供應商列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 *
 * @returns {Promise}
 */
const getSupplierList = ({
  order_by_id,
  order_by_sort,
  limit,
  offset,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/supplier/getList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 新增產品
 * @param {Json}   prodData                prodData
 * @param {String} [prodData.supplierID]   supplierID
 * @param {String} prodData.customID       customID
 * @param {String} [prodData.type]         type
 * @param {String} prodData.name           name
 * @param {Object} prodData.drugInfo       drugInfo
 * @param {Object} prodData.controlledDrugInfo   controlledDrugInfo
 * @param {String} [prodData.barcode]      barcode
 * @param {String} [prodData.unit]         unit
 * @param {String} [prodData.price]        price
 * @param {String} [prodData.discount]     discount
 * @param {String} prodData.sellTaxMode    sellTaxMode(0:稅外加/1:內含稅)
 * @param {String} [prodData.info]         info
 *
 * @returns {Promise}
 */
const createProd = ({
  supplierID,
  customID,
  type,
  name,
  drugInfo,
  controlledDrugInfo,
  safetyStock,
  sellUnit,
  barcode,
  unit,
  price,
  discount,
  sellTaxMode,
  info,
  level1,
  level2,
  level3,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    supplierID,
    customID,
    type,
    name,
    drugInfo,
    controlledDrugInfo,
    safetyStock,
    sellUnit,
    barcode,
    unit,
    price,
    discount,
    sellTaxMode,
    info,
    level1,
    level2,
    level3,
  };

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/prod`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得產品資訊
 * @param {String} prodID   prodID
 *
 * @returns {Promise}
 */
const getProdData = (prodID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/prod/${prodID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得產品ID by 條碼
 * @param {String} barcode   barcode
 *
 * @returns {Promise}
 */
const getProdIdByBarcode = (barcode) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/prod/barcode/${barcode}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得批次產品資訊
 * @param {Array}  prodIDs     prodIDs
 *
 * @returns {Promise}
 */
const getMultiProdData = (prodIDs) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = { prodIDs };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/multiProd`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新產品資訊
 * @param {Json}   prodData                prodData
 * @param {String} [prodData.supplierID]   supplierID
 * @param {String} prodData.prodID         prodID
 * @param {String} prodData.customID       customID
 * @param {String} [prodData.type]         type
 * @param {String} prodData.name           name
 * @param {Object} prodData.drugInfo       drugInfo
 * @param {Object} prodData.controlledDrugInfo   controlledDrugInfo
 * @param {String} [prodData.barcode]      barcode
 * @param {String} [prodData.unit]         unit
 * @param {String} [prodData.price]        price
 * @param {String} [prodData.discount]     discount
 * @param {Number} prodData.sellTaxMode    sellTaxMode(0:稅外加/1:內含稅)
 * @param {String} [prodData.info]         info
 *
 * @returns {Promise}
 */
const updateProdData = ({
  supplierID,
  prodID,
  customID,
  type,
  name,
  drugInfo,
  controlledDrugInfo,
  sellUnit,
  barcode,
  unit,
  price,
  discount,
  safetyStock,
  sellTaxMode,
  insideInfo,
  info,
  level1,
  level2,
  level3,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    supplierID,
    customID,
    type,
    name,
    drugInfo,
    controlledDrugInfo,
    sellUnit: sellUnit ? sellUnit : null,
    barcode,
    unit,
    price,
    discount,
    safetyStock,
    sellTaxMode,
    insideInfo,
    info,
    level1,
    level2,
    level3,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/prod/${prodID}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新批號資訊
 * @param {Json}   lotData           lotData
 * @param {String} lotData.lotID       lotID
 * @param {String} lotData.status    status
 *
 * @returns {Promise}
 */
const updateLotData = ({ lotID, status }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    lotID: lotID,
    status: status,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/lot/${data.lotID}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除產品
 * @param {String} prodID   prodID
 *
 * @returns {Promise}
 */
const deleteProd = (prodID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/prod/${prodID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得產品列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Object} [option.condition]      The search condition.{key:value}
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 *
 * @returns {Promise}
 */
const getProdList = ({
  order_by_id,
  order_by_sort,
  condition,
  columns,
  limit,
  offset,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  if (condition) {
    data["condition"] = condition;
  }
  if (columns) {
    data["columns"] = columns;
  }

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/prod/getList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得產品資訊列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 *
 * @returns {Promise}
 */
const getProdInfoList = ({
  order_by_id,
  order_by_sort,
  limit,
  offset,
  withoutStock,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  if (withoutStock !== null) {
    data["withoutStock"] = withoutStock;
  }
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/prod/getInfoList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得管制藥品資訊列表
 *
 * @returns {Promise}
 */
const getCDInfoList = () => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/prod/getCDInfoList`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得管制藥品資訊列表
 *
 * @returns {Promise}
 */
const getCDSimpleInfoByIDS = (ids) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/cdrug/getCDSimpleInfoByIDS`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ ids }),
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 新增耗材組合
 * @param {Json}   packageData                packageData
 * @param {String} packageData.name           名稱
 * @param {String} packageData.price          價格
 * @param {String} packageData.info           備註
 * @param {Object[]}  packageData.items       組合品項
 * @param {String}  packageData.items._id     品項id
 * @param {Number}  packageData.items.amount  品項數量
 *
 * @returns {Promise}
 */
const createPackage = ({ name, price, info, items }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    name,
    price,
    info,
    items,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/package`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得耗材組合清單
 * @param {String}  limit
 * @param {Number}  offset
 *
 * @returns {Promise}
 */
const getPackageList = (limit, offset) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (limit && offset) {
    data = {
      limit,
      offset,
    };
  }
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/package/getList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};
/**
 * 取得耗材組合
 * @param {String}  id
 *
 * @returns {Promise}
 */
const getPackage = (id) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/package/${id}`,
      dataType: "json",
      contentType: "application/json",

      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新耗材組合
 * @param {String}  id
 * @param {Json}   packageData                packageData
 * @param {String} packageData.name           名稱
 * @param {String} packageData.price          價格
 * @param {String} packageData.info           備註
 * @param {Object[]}  packageData.items       組合品項
 * @param {String}  packageData.items._id     品項id
 * @param {Number}  packageData.items.amount  品項數量
 *
 * @returns {Promise}
 */
const updatePackage = (id, { name, price, info, items }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    name,
    price,
    info,
    items,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/package/${id}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除耗材組合
 * @param {String}  id
 *
 * @returns {Promise}
 */
const deletePackage = (id) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/package/${id}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 新增耗材組合
 * @param {Json}   prodLevelData               prodLevelData
 * @param {String} prodLevelData.type          價格
 * @param {String} prodLevelData.name          名稱
 * @param {String} prodLevelData.parentID      備註
 *
 * @returns {Promise}
 */
const createProdLevel = ({ type, name, parentID }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = { type, name, parentID };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/prodLevel`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得商品分層清單
 *
 * @returns {Promise}
 */
const getProdLevelList = () => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/prodLevel/getList`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得商品分層
 * @param {String}  id
 *
 * @returns {Promise}
 */
const getProdLevel = (id) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/prodLevel/${id}`,
      dataType: "json",
      contentType: "application/json",

      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新商品分層
 * @param {String}  id
 * @param {String} name           名稱
 *
 * @returns {Promise}
 */
const updateProdLevel = (id, name) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/prodLevel/${id}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ name }),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除商品分層
 * @param {String}  id
 *
 * @returns {Promise}
 */
const deleteProdLevel = (id) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/prodLevel/${id}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新多商品層級
 * @param {Object}  paras
 * @param {String}  prodIDs    修改商品ID array
 * @param {String}  level1     層級1ID
 * @param {String}  level2     層級2ID
 * @param {String}  level3     層級3ID
 *
 * @returns {Promise}
 */
const updateMultiProd = (paras) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/prod/multiUpdateProd`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(paras),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得檢驗項目清單
 * @param {String}  limit
 * @param {Number}  offset
 *
 * @returns {Promise}
 */
const getExamList = (type = "檢驗") => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    type,
  };

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/item/service/getList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得檢驗儀器清單
 *
 * @returns {Promise}
 */
const getVendorList = () => {
  let customerID = localStorage.getItem("CLINIC");

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/item/exam/getVendorList`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 新增服務
 * @param {Json}   serviceData                serviceData
 * @param {String} serviceData.serviceClass   大分類
 * @param {String} serviceData.type           類別
 * @param {String} serviceData.name           名稱
 * @param {String} serviceData.price          價格
 * @param {String} serviceData.vendor         儀器廠牌
 * @param {String} serviceData.device         儀器名稱
 * @param {String[]} serviceData.kinds        適合的寵物種類
 * @param {String} serviceData.info           備註
 * @param {Object[]}  serviceData.items       服務細項
 * @param {String}    serviceData.items._id     細項id
 * @param {Number}    serviceData.items.amount  細項數量
 * @param {Object[]}  serviceData.customItems             自訂檢驗
 * @param {String}  serviceData.customItems.type          檢驗類型
 * @param {Number}  serviceData.customItems.item          檢驗名稱
 * @param {Number}  serviceData.customItems.vendor        檢驗設備
 * @param {Number}  serviceData.customItems.device        檢驗儀器
 * @param {Number}  serviceData.customItems.itemOrder     排序
 * @param {Number}  serviceData.customItems.unit          檢驗單位
 * @param {Number}  serviceData.customItems.standardlow   參考範圍
 * @param {Number}  serviceData.customItems.standardhigh  參考範圍
 * @param {Number}  serviceData.customItems.info          備註範圍
 * @param {Object[]}  serviceData.examSupplies       檢驗耗材
 * @param {String}    serviceData.examSupplies._id     品項id
 * @param {Number}    serviceData.examSupplies.amount  品項數量
 *
 * @returns {Promise}
 */
const createService = ({
  serviceClass,
  type,
  name,
  price,
  vendor,
  device,
  kinds,
  info,
  items,
  customItems,
  examSupplies,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    class: serviceClass,
    type,
    name,
    price,
    vendor,
    device,
    kinds,
    info,
    items,
    customItems,
    examSupplies,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/serving`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得服務項目清單
 * @param {String} serviceClass   服務大分類
 * @param {String} type           服務
 *
 * @returns {Promise}
 */
const getServiceList = ({ serviceClass, type }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (serviceClass) {
    data.class = serviceClass;
  }
  if (type) {
    data.type = type;
  }

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/serving/getList`,
      dataType: "json",
      data: JSON.stringify(data),
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得服務項目
 *
 * @returns {Promise}
 */
const getService = (id) => {
  let customerID = localStorage.getItem("CLINIC");

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/serving/${id}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新服務
 * @param {Json}   serviceData                serviceData
 * @param {String} serviceData.serviceClass   大分類
 * @param {String} serviceData.type           類別
 * @param {String} serviceData.name           名稱
 * @param {String} serviceData.price          價格
 * @param {String} serviceData.vendor         儀器廠牌
 * @param {String} serviceData.device         儀器名稱
 * @param {String[]} serviceData.kinds        適合的寵物種類
 * @param {String} serviceData.info           備註
 * @param {Object[]}  serviceData.items       服務細項
 * @param {String}    serviceData.items._id     品項id
 * @param {Number}    serviceData.items.amount  品項數量
 * @param {Object[]}  serviceData.customItems             自訂檢驗
 * @param {String}  serviceData.customItems.type          檢驗類型
 * @param {Number}  serviceData.customItems.item          檢驗名稱
 * @param {Number}  serviceData.customItems.vendor        檢驗設備
 * @param {Number}  serviceData.customItems.device        檢驗儀器
 * @param {Number}  serviceData.customItems.itemOrder     排序
 * @param {Number}  serviceData.customItems.unit          檢驗單位
 * @param {Number}  serviceData.customItems.standardlow   參考範圍
 * @param {Number}  serviceData.customItems.standardhigh  參考範圍
 * @param {Number}  serviceData.customItems.info          備註範圍
 * @param {Object[]}  serviceData.examSupplies       檢驗耗材
 * @param {String}    serviceData.examSupplies._id     品項id
 * @param {Number}    serviceData.examSupplies.amount  品項數量
 *
 *
 * @returns {Promise}
 */
const updateService = (
  id,
  {
    serviceClass,
    type,
    name,
    price,
    vendor,
    device,
    kinds,
    info,
    items,
    customItems,
    examSupplies,
    sequence,
  }
) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    class: serviceClass,
    type,
    name,
    price,
    vendor,
    device,
    kinds,
    info,
    items,
    customItems,
    examSupplies,
    sequence,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/serving/${id}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新服務排序
 * @param {Json}   serviceData                serviceData
 * @param {String} serviceData.serviceClass   大分類
 * @param {String} serviceData.type           類別
 * @param {String} serviceData.name           名稱
 * @param {String} serviceData.price          價格
 *
 *
 * @returns {Promise}
 */
const updateServiceSequence = (ids) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    ids: ids,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/serving/sequence`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除服務項目
 *
 * @returns {Promise}
 */
const deleteService = (id) => {
  let customerID = localStorage.getItem("CLINIC");

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/serving/${id}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得檢驗順序
 * @param {String} serviceClass   服務大分類
 * @param {String} type           服務
 *
 * @returns {Promise}
 */
const getExamOrders = ({ serviceClass, type }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (serviceClass) {
    data.class = serviceClass;
  }
  if (type) {
    data.type = type;
  }

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/serving/getExamOrders`,
      dataType: "json",
      data: JSON.stringify(data),
      contentType: "application/json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得產品進出明細
 *
 * @param {String}    prodID                    prodID
 * @param {Json}      dateCondition             dateCondition
 * @param {TimeStamp} dateCondition.startDate   startDate
 * @param {TimeStamp} [dateCondition.endDate]   endDate
 *
 * @returns {Promise}
 */
const getProdStockList = (prodID, { startDate, endDate }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/prod/${prodID}/stock`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 根據ID取得產品庫存和安全庫存
 *
 * @param {String}    prodIDs     prodIDs
 *
 * @returns {Promise}
 */
const getStockByIds = (prodIDs) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/prod/getStockByIds`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ prodIDs }),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 新增付款單
 * @param {Json}       data                     data
 * @param {String}     data.customID            customID
 * @param {Date}       data.paymentDate         paymentDate
 * @param {String}     data.supplierID          supplierID
 * @param {Number}     data.cashAmount          cashAmount
 * @param {Number}     data.transferAmount      transferAmount
 * @param {String}     data.transferFrom        transferFrom
 * @param {String}     data.transferTo          transferTo
 * @param {Number}     data.checkAmount         checkAmount
 * @param {String}     data.checkNumber         checkNumber
 * @param {Date}       data.checkExpiryDate     checkExpiryDate
 * @param {Number}     data.totalAmount         totalAmount
 * @param {String}     data.staffID         staffID
 * @param {String}     data.staffName       staffName
 *
 * @returns {Promise}
 */
const createFormForPayment = ({
  customID,
  paymentDate,
  supplierID,
  cashAmount,
  transferAmount,
  transferFrom,
  transferTo,
  creditAmount,
  creditLastNumber,
  checkAmount,
  checkNumber,
  checkExpiryDate,
  otherAmount,
  otherDescription,
  totalAmount,
  staffID,
  staffName,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customID,
    paymentDate,
    supplierID,
    cashAmount,
    transferAmount,
    transferFrom,
    transferTo,
    creditAmount,
    creditLastNumber,
    checkAmount,
    checkNumber,
    checkExpiryDate,
    otherAmount,
    otherDescription,
    totalAmount,
    staffID,
    staffName,
  };

  return createForm(customerID, "payment", data);
};

/**
 * 新增進貨單
 * @param {Json}       formData                 formData
 * @param {String}     formData.supplierID      supplierID
 * @param {String}     formData.customID        customID
 * @param {String}     [formData.orderID]       orderID
 * @param {TimeStamp}  formData.purchaseDate    purchaseDate
 * @param {TimeStamp}  formData.paymentTerm     paymentTerm
 * @param {String}     formData.staffID         staffID
 * @param {String}     formData.staffName       staffName
 * @param {Number}     formData.taxMode         taxMode
 * @param {Number}     formData.arrive          arrive
 * @param {String}     [formData.info]          info
 * @param {JsonArray}  [formData.items]         items
 * @param {String}     formData.items.orderID   orderID
 * @param {String}     formData.items.prodID    prodID
 * @param {Number}     formData.items.amount    amount
 * @param {Number}     formData.items.batch     batch
 * @param {Number}     [formData.items.unit]    unit
 * @param {Number}     formData.items.price     price
 * @param {Number}     formData.items.total     total
 * @param {Number}     formData.items.tax       tax
 * @param {Date}       [formData.items.mfDate]  mfDate
 * @param {Date}       [formData.items.expDate] expDate
 * @param {String}     [formData.items.info]    info
 *
 * @returns {Promise}
 */
const createFormForPurchase = ({
  supplierID,
  customID,
  orderID,
  purchaseDate,
  paymentTerm,
  staffID,
  staffName,
  taxMode,
  info,
  arrive,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    orderID,
    supplierID,
    purchaseDate,
    paymentTerm,
    staffID,
    staffName,
    taxMode,
    arrive,
    info,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return createForm(customerID, "purchase", data);
};

/**
 * 新增採購單
 * @param {Json}       formData                 formData
 * @param {String}     formData.supplierID      supplierID
 * @param {String}     formData.customID        customID
 * @param {String}     [formData.orderID]       orderID
 * @param {TimeStamp}  formData.orderDateTime   orderDateTime
 * @param {TimeStamp}  formData.paymentTerm     paymentTerm
 * @param {String}     formData.staffID         staffID
 * @param {String}     formData.staffName       staffName
 * @param {Number}     formData.taxMode         taxMode
 * @param {String}     [formData.info]          info
 * @param {JsonArray}  [formData.items]         items
 * @param {String}     formData.items.orderID   orderID
 * @param {String}     formData.items.prodID    prodID
 * @param {Number}     formData.items.amount    amount
 * @param {Number}     formData.items.batch     batch
 * @param {Number}     [formData.items.unit]    unit
 * @param {Number}     formData.items.price     price
 * @param {Number}     formData.items.total     total
 * @param {Number}     formData.items.tax       tax
 * @param {Date}       [formData.items.mfDate]  mfDate
 * @param {Date}       [formData.items.expDate] expDate
 * @param {String}     [formData.items.info]    info
 *
 * @returns {Promise}
 */
const createFormForOrder = ({
  supplierID,
  customID,
  orderID,
  orderDateTime,
  paymentTerm,
  staffID,
  staffName,
  taxMode,
  info,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    orderID,
    supplierID,
    orderDateTime,
    paymentTerm,
    staffID,
    staffName,
    taxMode,
    info,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return createForm(customerID, "order", data);
};

/**
 * 新增銷售單
 *
 * @param {Json}      formData                 formData
 * @param {String}    formData.customID        customID
 * @param {String}    [formData.clientID]      clientID
 * @param {String}    [formData.clientName]    clientName
 * @param {TimeStamp} formData.sellDateTime    sellDateTime
 * @param {String}    formData.staffID         staffID
 * @param {String}    formData.staffName       staffName
 * @param {String}    [formData.info]          info
 * @param {Number}    [formData.taxMode]       taxMode
 * @param {JsonArray} [formData.items]         items
 * @param {String}    formData.items.orderID   orderID
 * @param {String}    formData.items.prodID    prodID
 * @param {Number}    formData.items.amount    amount
 * @param {String}    [formData.items.unit]    unit
 * @param {Number}    formData.items.price     price
 * @param {String}    formData.items.priceMode priceMode
 * @param {Number}    formData.items.total     total
 * @param {Number}    formData.items.tax       tax
 * @param {String}    [formData.items.info]    info
 *
 * @returns {Promise}
 */
const createFormForSell = ({
  customID,
  clientID,
  clientName,
  sellDateTime,
  staffID,
  staffName,
  info,
  taxMode,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    clientID,
    clientName,
    sellDateTime,
    staffID,
    staffName,
    info,
    taxMode,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return createForm(customerID, "sell", data);
};

/**
 * 新增盤點單
 *
 * @param {Json}      formData                 formData
 * @param {String}    formData.customID        customID
 * @param {TimeStamp} formData.checkDateTime   checkDateTime
 * @param {String}    formData.reason          reason
 * @param {String}    formData.staffID         staffID
 * @param {String}    formData.staffName       staffName
 * @param {String}    [formData.info]          info
 * @param {JsonArray} [formData.items]         items
 * @param {String}    formData.items.orderID   orderID
 * @param {String}    formData.items.prodID    prodID
 * @param {Number}    formData.items.expect    expect
 * @param {Number}    formData.items.reality   reality
 * @param {String}    [formData.items.info]    info
 *
 * @returns {Promise}
 */
const createFormForCheck = ({
  customID,
  checkDateTime,
  reason,
  type,
  staffID,
  staffName,
  info,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    checkDateTime,
    reason,
    type,
    staffID,
    staffName,
    info,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return createForm(customerID, "check", data);
};

/**
 * 新增退貨單
 * @param {Json}       formData                 formData
 * @param {String}     formData.supplierID      supplierID
 * @param {String}     formData.customID        customID
 * @param {String}     formData.purchaseID      purchaseID
 * @param {Date}       formData.returnDateTime  returnDateTime
 * @param {String}     formData.staffID         staffID
 * @param {String}     formData.staffName       staffName
 * @param {Number}     formData.taxMode         taxMode
 * @param {String}     [formData.info]          info
 * @param {JsonArray}  [formData.items]         items
 * @param {String}     formData.items.orderID   orderID
 * @param {String}     formData.items.prodID    prodID
 * @param {Number}     formData.items.amount    amount
 * @param {Number}     formData.items.batch     batch
 * @param {Number}     [formData.items.unit]    unit
 * @param {Number}     formData.items.price     price
 * @param {Number}     formData.items.total     total
 * @param {Number}     formData.items.tax       tax
 * @param {String}     [formData.items.info]    info
 *
 * @returns {Promise}
 */
const createFormForReturn = ({
  supplierID,
  customID,
  purchaseID,
  returnDateTime,
  staffID,
  staffName,
  taxMode,
  info,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    purchaseID,
    supplierID,
    returnDateTime,
    staffID,
    staffName,
    taxMode,
    info,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return createForm(customerID, "return", data);
};

const createForm = (customerID, type, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/form/${type}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得進貨單資訊
 * @param {String} formID   formID
 *
 * @returns {Promise}
 */
const getFormDataForPurchase = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return getFormData(customerID, "purchase", formID);
};

/**
 * 獲得採購單資訊
 * @param {String} formID   formID
 *
 * @returns {Promise}
 */
const getFormDataForOrder = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return getFormData(customerID, "order", formID);
};

/**
 * 獲得銷售單資訊
 * @param {String} formID   formID
 *
 * @returns {Promise}
 */
const getFormDataForSell = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return getFormData(customerID, "sell", formID);
};

/**
 * 獲得盤點單資訊
 * @param {String} formID   formID
 *
 * @returns {Promise}
 */
const getFormDataForCheck = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return getFormData(customerID, "check", formID);
};

const getFormData = (customerID, type, formID) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/form/${type}/${formID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新付款單資訊
 *
 * @param {Json}        formData                 formData
 * @param {String}      formData.formID          formID

 *
 * @returns {Promise}
 */
const updateFormDataForPayment = (data) => {
  let customerID = localStorage.getItem("CLINIC");
  let formID = data.formID;
  delete data.formID;

  return updateFormData(customerID, "payment", formID, data);
};

/**
 * 更新進貨單資訊
 *
 * @param {Json}        formData                 formData
 * @param {String}      formData.supplierID      supplierID
 * @param {String}      formData.formID          formID
 * @param {String}      formData.customID        customID
 * @param {String}      [formData.orderID]       orderID
 * @param {TimeStamp}   formData.purchaseDate    purchaseDate
 * @param {TimeStamp}   formData.paymentTerm     paymentTerm
 * @param {String}      formData.staffID         staffID
 * @param {Number}      formData.taxMode         taxMode
 * @param {String}      [formData.info]          info
 * @param {JsonArray}   [formData.items]         items
 * @param {String}      formData.items.orderID   orderID
 * @param {String}      formData.items.prodID    prodID
 * @param {Number}      formData.items.amount    amount
 * @param {Number}      formData.items.batch     batch
 * @param {Number}      [formData.items.unit]    unit
 * @param {Number}      formData.items.price     price
 * @param {Number}      formData.items.total     total
 * @param {Number}      formData.items.tax       tax
 * @param {Date}        [formData.items.mfDate]  mfDate
 * @param {Date}        [formData.items.expDate] expDate
 * @param {String}      [formData.items.info]    info
 *
 * @returns {Promise}
 */
const updateFormDataForPurchase = ({
  supplierID,
  formID,
  customID,
  orderID,
  purchaseDate,
  paymentTerm,
  staffID,
  taxMode,
  info,
  paymentID,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    orderID,
    supplierID,
    purchaseDate,
    paymentTerm,
    staffID,
    taxMode,
    info,
    paymentID,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return updateFormData(customerID, "purchase", formID, data);
};

/**
 * 更新採購單資訊
 *
 * @param {Json}        formData                 formData
 * @param {String}      formData.supplierID      supplierID
 * @param {String}      formData.formID          formID
 * @param {String}      formData.customID        customID
 * @param {String}      [formData.orderID]       orderID
 * @param {TimeStamp}   formData.orderDateTime   orderDateTime
 * @param {TimeStamp}   formData.paymentTerm     paymentTerm
 * @param {String}      formData.staffID         staffID
 * @param {Number}      formData.taxMode         taxMode
 * @param {Number}      formData.status          status
 * @param {String}      [formData.info]          info
 * @param {JsonArray}   [formData.items]         items
 * @param {String}      formData.items.orderID   orderID
 * @param {String}      formData.items.prodID    prodID
 * @param {Number}      formData.items.amount    amount
 * @param {Number}      formData.items.batch     batch
 * @param {Number}      [formData.items.unit]    unit
 * @param {Number}      formData.items.price     price
 * @param {Number}      formData.items.total     total
 * @param {Number}      formData.items.tax       tax
 * @param {Date}        [formData.items.mfDate]  mfDate
 * @param {Date}        [formData.items.expDate] expDate
 * @param {String}      [formData.items.info]    info
 *
 * @returns {Promise}
 */
const updateFormDataForOrder = ({
  supplierID,
  formID,
  customID,
  orderID,
  orderDateTime,
  paymentTerm,
  staffID,
  arrive,
  taxMode,
  status = 0,
  info,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    orderID,
    supplierID,
    orderDateTime,
    paymentTerm,
    staffID,
    arrive,
    taxMode,
    status,
    info,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return updateFormData(customerID, "order", formID, data);
};

/**
 * 更新銷售單資訊
 *
 * @param {Json}      formData                 formData
 * @param {String}    formData.formID          formID
 * @param {String}    formData.customID        customID
 * @param {String}    [formData.clientID]      clientID
 * @param {String}    [formData.clientName]    clientName
 * @param {TimeStamp} formData.sellDateTime    sellDateTime
 * @param {String}    formData.staffID         staffID
 * @param {String}    [formData.info]          info
 * @param {Number}    [formData.taxMode]       taxMode
 * @param {JsonArray} [formData.items]         items
 * @param {String}    formData.items.orderID   orderID
 * @param {String}    formData.items.prodID    prodID
 * @param {Number}    formData.items.amount    amount
 * @param {String}    [formData.items.unit]    unit
 * @param {Number}    formData.items.price     price
 * @param {String}    formData.items.priceMode priceMode
 * @param {Number}    formData.items.total     total
 * @param {Number}    formData.items.tax       tax
 * @param {String}    [formData.items.info]    info
 *
 * @returns {Promise}
 */
const updateFormDataForSell = ({
  formID,
  customID,
  clientID,
  clientName,
  sellDateTime,
  staffID,
  info,
  taxMode,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    clientID,
    clientName,
    sellDateTime,
    staffID,
    taxMode,
    info,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return updateFormData(customerID, "sell", formID, data);
};

/**
 * 更新盤點單資訊
 *
 * @param {Json}      formData                 formData
 * @param {String}    formData.formID          formID
 * @param {String}    formData.customID        customID
 * @param {TimeStamp} formData.checkDateTime   checkDateTime
 * @param {String}    formData.reason          reason
 * @param {String}    formData.staffID         staffID
 * @param {String}    [formData.info]          info
 * @param {JsonArray} [formData.items]         items
 * @param {String}    formData.items.orderID   orderID
 * @param {String}    formData.items.prodID    prodID
 * @param {Number}    formData.items.expect    expect
 * @param {Number}    formData.items.reality   reality
 * @param {String}    [formData.items.info]    info
 *
 * @returns {Promise}
 */
const updateFormDataForCheck = ({
  formID,
  customID,
  checkDateTime,
  reason,
  type,
  staffID,
  staffName,
  info,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    customID,
    checkDateTime,
    reason,
    type,
    staffID,
    staffName,
    info,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return updateFormData(customerID, "check", formID, data);
};

/**
 * 更新退貨單資訊
 *
 * @param {Json}        formData                 formData
 * @param {String}      formData.supplierID      supplierID
 * @param {String}      formData.formID          formID
 * @param {String}      formData.customID        customID
 * @param {String}      formData.purchaseID      purchaseID
 * @param {TimeStamp}   formData.returnDateTime  returnDateTime
 * @param {String}      formData.staffID         staffID
 * @param {String}      formData.staffName       staffName
 * @param {Number}      formData.taxMode         taxMode
 * @param {String}      [formData.info]          info
 * @param {JsonArray}   [formData.items]         items
 * @param {String}      formData.items.orderID   orderID
 * @param {String}      formData.items.prodID    prodID
 * @param {Number}      formData.items.amount    amount
 * @param {Number}      formData.items.batch     batch
 * @param {Number}      [formData.items.unit]    unit
 * @param {Number}      formData.items.price     price
 * @param {Number}      formData.items.total     total
 * @param {Number}      formData.items.tax       tax
 * @param {String}      [formData.items.info]    info
f *
 * @returns {Promise}
 */
const updateFormDataForReturn = ({
  supplierID,
  formID,
  customID,
  purchaseID,
  returnDateTime,
  staffID,
  staffName,
  taxMode,
  info,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    supplierID,
    customID,
    purchaseID,
    returnDateTime,
    staffID,
    staffName,
    taxMode,
    info,
  };
  if (items !== null && Array.isArray(items)) {
    data["items"] = items;
  }
  return updateFormData(customerID, "return", formID, data);
};

const updateFormData = (customerID, type, formID, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/form/${type}/${formID}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除付款單
 *
 * @returns {Promise}
 */
const deleteFormForPayment = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return deleteForm(customerID, "payment", formID);
};

/**
 * 刪除進貨單
 *
 * @returns {Promise}
 */
const deleteFormForPurchase = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return deleteForm(customerID, "purchase", formID);
};

/**
 * 刪除採購單
 *
 * @returns {Promise}
 */
const deleteFormForOrder = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return deleteForm(customerID, "order", formID);
};

/**
 * 刪除銷售單
 *
 * @returns {Promise}
 */
const deleteFormForSell = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return deleteForm(customerID, "sell", formID);
};

/**
 * 刪除盤點單
 *
 * @returns {Promise}
 */
const deleteFormForCheck = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return deleteForm(customerID, "check", formID);
};

/**
 * 刪除退貨單
 *
 * @returns {Promise}
 */
const deleteFormForReturn = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return deleteForm(customerID, "return", formID);
};

const deleteForm = (customerID, type, formID) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/form/${type}/${formID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得進貨單資訊列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 * @param {Date}   [option.start]          The start of result
 * @param {Date}   [option.end]            The end of result
 *
 * @returns {Promise}
 */
const getCountForSuppliers = ({
  condition,
  limit,
  offset,
  start,
  end,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (condition) {
    data["condition"] = condition;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  if (start && end) {
    data["dateRange"] = {
      start: start,
      end: end,
    };
  }

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/supplier/payments`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得進貨單列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 *
 * @returns {Promise}
 */
const getFormListForPurchase = ({
  order_by_id,
  order_by_sort,
  limit,
  offset,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  return getFormList(customerID, "purchase", data);
};

/**
 * 獲得銷售單列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 *
 * @returns {Promise}
 */
const getFormListForSell = ({
  order_by_id,
  order_by_sort,
  limit,
  offset,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  return getFormList(customerID, "sell", data);
};

/**
 * 獲得盤點單列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 *
 * @returns {Promise}
 */
const getFormListForCheck = ({
  order_by_id,
  order_by_sort,
  limit,
  offset,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  return getFormList(customerID, "check", data);
};

const getFormList = (customerID, type, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/form/${type}/getList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得付款單資訊列表
 *
 * @param {Json}   [option]                Option for search
 * @param {Date}   [option.start]          The start of result
 * @param {Date}   [option.end]            The end of result
 *
 * @returns {Promise}
 */
const getFormInfoListForPayment = ({ start, end } = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (start && end) {
    data["dateRange"] = {
      start: start,
      end: end,
    };
  }
  return getFormInfoList(customerID, "payment", data);
};

/**
 * 獲得進貨單資訊列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 * @param {Date}   [option.start]          The start of result
 * @param {Date}   [option.end]            The end of result
 *
 * @returns {Promise}
 */
const getFormInfoListForPurchase = ({
  _id,
  order_by_id,
  order_by_sort,
  condition,
  limit,
  offset,
  start,
  end,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (_id) {
    if (condition) condition["_id"] = _id;
    else condition = { _id: _id };
  }
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (condition) {
    data["condition"] = condition;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  if (start && end) {
    data["dateRange"] = {
      start: start,
      end: end,
    };
  }
  return getFormInfoList(customerID, "purchase", data);
};

/**
 * 獲得採購單資訊列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 *
 * @returns {Promise}
 */

const getFormInfoListForOrder = ({
  order_by_id,
  order_by_sort,
  condition,
  limit,
  offset,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (condition) {
    data["condition"] = condition;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  return getFormInfoList(customerID, "order", data);
};

/**
 * 獲得銷售單資訊列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 *
 * @returns {Promise}
 */
const getFormInfoListForSell = ({
  order_by_id,
  order_by_sort,
  limit,
  offset,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  return getFormInfoList(customerID, "sell", data);
};

/**
 * 獲得盤點單資訊列表
 *
 * @param {Json}   [option]                Option for search
 * @param {String} [option.order_by_id]    The order by id
 * @param {String} [option.order_by_sort]  The order by sort (ASC | DESC)
 * @param {Number} [option.limit]          The limit of result
 * @param {Number} [option.offset]         The offset of result
 *
 * @returns {Promise}
 */
const getFormInfoListForCheck = ({
  order_by_id,
  order_by_sort,
  limit,
  offset,
} = {}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  let order_json = {};
  if (order_by_id !== null) {
    order_json["column"] = order_by_id;
  }
  if (order_by_sort !== null) {
    order_json["order"] = order_by_sort;
  }
  if (order_json != {}) {
    data["order"] = order_json;
  }
  if (limit !== null) {
    data["limit"] = limit;
  }
  if (offset !== null) {
    data["offset"] = offset;
  }
  return getFormInfoList(customerID, "check", data);
};

const getFormInfoList = (customerID, type, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/form/${type}/getInfoList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 依據病歷內容銷貨進消存商品與服務
 */
const createSellFormByRecord = (record) => {
  return new Promise(function (resolve, reject) {
    let customerID = localStorage.getItem("CLINIC");
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/customer/sellProd`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(record),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 依據住院內容銷貨進消存商品與服務
 */
const createSellFormByInHospital = (inHospital) => {
  return new Promise(function (resolve, reject) {
    let customerID = localStorage.getItem("CLINIC");
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/customer/sellProdHospital`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(inHospital),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

//deleteSellFormByRecord
/**
 * 清除病歷與住院銷貨內容
 */
const deleteSellForm = (recourceIDArray) => {
  return new Promise(function (resolve, reject) {
    let customerID = localStorage.getItem("CLINIC");
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/customer/sellProd`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(recourceIDArray),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 新增類別設定
 *
 * @param {Json}   settingData        settingData
 * @param {String} settingData.type   type
 * @param {String} [settingData.info]  info
 *
 * @returns {Promise}
 */
const createCustomerSettingForType = ({ type, info }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    type,
    info,
  };
  return createCustomerSetting(customerID, "type", data);
};

/**
 * 新增單位設定
 *
 * @param {Json}   settingData        settingData
 * @param {String} settingData.unit   unit
 * @param {String} [settingData.info]  info
 *
 * @returns {Promise}
 */
const createCustomerSettingForUnit = ({ unit, info }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    unit,
    info,
  };
  return createCustomerSetting(customerID, "unit", data);
};

/**
 * 新增服務class
 *
 * @param {Json}   settingData        settingData
 * @param {String} settingData.serviceClass   serviceClass
 * @param {String} [settingData.info]  info
 *
 * @returns {Promise}
 */
const createCustomerSettingForServiceClass = ({ serviceClass, info }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    class: serviceClass,
    info,
  };
  return createCustomerSetting(customerID, "serviceClass", data);
};

/**
 * 新增服務type
 *
 * @param {Json}   settingData        settingData
 * @param {String} settingData.serviceClass   serviceClass
 * @param {String} settingData.type   type
 * @param {String} [settingData.info]  info
 *
 * @returns {Promise}
 */
const createCustomerSettingForServiceType = ({ serviceClass, type, info }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    class: serviceClass,
    type,
    info,
  };
  return createCustomerSetting(customerID, "service", data);
};

const createCustomerSetting = (customerID, type, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/setting/${type}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得設定
 *
 * @returns {Promise}
 */
const getCustomerSettingForAll = () => {
  let customerID = localStorage.getItem("CLINIC");
  return getCustomerSetting(customerID, "all");
};

/**
 * 獲得類別設定
 *
 * @returns {Promise}
 */
const getCustomerSettingForType = () => {
  let customerID = localStorage.getItem("CLINIC");
  return getCustomerSetting(customerID, "type");
};

/**
 * 獲得單位設定
 *
 * @returns {Promise}
 */
const getCustomerSettingForUnit = () => {
  let customerID = localStorage.getItem("CLINIC");
  return getCustomerSetting(customerID, "unit");
};

/**
 * 獲得單位設定
 *
 * @returns {Promise}
 */
const getCustomerSettingByType = (type) => {
  let customerID = localStorage.getItem("CLINIC");
  return getCustomerSetting(customerID, type);
};

const getCustomerSetting = (customerID, type) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/setting/${type}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新類別設定
 *
 * @param {Json}   settingData             settingData
 * @param {String} settingData.settingID   settingID
 * @param {String} settingData.unit        unit
 * @param {String} [settingData.info]      info
 *
 * @returns {Promise}
 */
const updateCustomerSettingForType = ({ settingID, type, info }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    type,
    info,
  };
  return updateCustomerSetting(customerID, "type", settingID, data);
};

/**
 * 設定單位設定
 *
 * @param {Json}   settingData            settingData
 * @param {String} settingData.settingID  settingID
 * @param {String} settingData.unit       unit
 * @param {String} [settingData.info]     info
 *
 * @returns {Promise}
 */
const updateCustomerSettingForUnit = ({ settingID, unit, info }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customerID,
    unit,
    info,
  };
  return updateCustomerSetting(customerID, "unit", settingID, data);
};

/**
 * 更新服務Class sequence
 * @param {Array}   ids             service class sequence
 * @returns {Promise}
 */
const updateServiceClassSequence = (ids) => {
  return updateCustomerSettingSequence("serviceClass", ids);
};

/**
 * 更新服務Type sequence
 * @param {Array}   ids             service type sequence
 * @returns {Promise}
 */
const updateServiceTypeSequence = (ids) => {
  return updateCustomerSettingSequence("service", ids);
};

const updateCustomerSetting = (customerID, type, settingID, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/setting/${type}/${settingID}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

const updateCustomerSettingSequence = (type, ids) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    ids: ids,
  };
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/setting/${type}/sequence`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除類別設定
 * @param {String} settingID       settingID
 *
 * @returns {Promise}
 */
const deleteCustomerSettingForType = (settingID) => {
  let customerID = localStorage.getItem("CLINIC");
  if (Array.isArray(settingID)) {
    return deleteCustomerSetting(customerID, "type", 0, settingID);
  } else {
    return deleteCustomerSetting(customerID, "type", settingID, {});
  }
};

/**
 * 刪除單位設定
 * @param {String} settingID       settingID
 *
 * @returns {Promise}
 */
const deleteCustomerSettingForUnit = (settingID) => {
  let customerID = localStorage.getItem("CLINIC");
  if (Array.isArray(settingID)) {
    return deleteCustomerSetting(customerID, "unit", 0, settingID);
  } else {
    return deleteCustomerSetting(customerID, "unit", settingID, {});
  }
};

/**
 * 刪除服務class
 * @param {String} settingID       settingID
 *
 * @returns {Promise}
 */
const deleteCustomerSettingForServiceClass = (settingID) => {
  let customerID = localStorage.getItem("CLINIC");
  if (Array.isArray(settingID)) {
    return deleteCustomerSetting(customerID, "serviceClass", 0, settingID);
  } else {
    return deleteCustomerSetting(customerID, "serviceClass", settingID, {});
  }
};

/**
 * 刪除服務type
 * @param {String} settingID       settingID
 *
 * @returns {Promise}
 */
const deleteCustomerSettingForServiceType = (settingID) => {
  let customerID = localStorage.getItem("CLINIC");
  if (Array.isArray(settingID)) {
    return deleteCustomerSetting(customerID, "service", 0, settingID);
  } else {
    return deleteCustomerSetting(customerID, "service", settingID, {});
  }
};

const deleteCustomerSetting = (customerID, type, settingID, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/setting/${type}/${settingID}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得採購單PDF文件
 *
 * @param {Json}   pdfData                   pdfData
 * @param {String} pdfData.customID          customID
 * @param {String} pdfData.checkDateTime     checkDateTime
 * @param {String} pdfData.reason            reason
 * @param {String} pdfData.staffID           staffID
 * @param {String} pdfData.items             items
 * @param {String} pdfData.items.expect      expect
 * @param {String} pdfData.items.prod        prod
 * @param {String} pdfData.items.customID    customID
 *
 * @returns {Promise}
 */
const getPdfForOrder = ({
  customID,
  orderDateTime,
  supplier,
  taxMode,
  staffName,
  info,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customID,
    orderDateTime,
    supplier,
    taxMode,
    staffName,
    info,
    items,
  };
  return getPdf(customerID, "orderForm", data);
};

/**
 * 獲得盤點PDF文件
 *
 * @param {Json}   pdfData                   pdfData
 * @param {String} pdfData.customID          customID
 * @param {String} pdfData.checkDateTime     checkDateTime
 * @param {String} pdfData.reason            reason
 * @param {String} pdfData.staffID           staffID
 * @param {String} pdfData.items             items
 * @param {String} pdfData.items.expect      expect
 * @param {String} pdfData.items.prod        prod
 * @param {String} pdfData.items.customID    customID
 *
 * @returns {Promise}
 */
const getPdfForCheck = ({
  customID,
  checkDateTime,
  reason,
  staffID,
  staffName,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customID,
    checkDateTime,
    reason,
    staffID,
    staffName,
    items,
  };
  return getPdf(customerID, "checkForm", data);
};

/**
 * 獲得管制藥品PDF文件
 * @deprecated
 * @param {Json}   pdfData                   pdfData
 * @param {String} pdfData.customID          customID
 * @param {String} pdfData.name              name
 * @param {String} pdfData.lot               lot
 * @param {String} pdfData.purchaseDateTime  purchaseDateTime
 * @param {String} pdfData.items             items
 * @param {String} pdfData.items.date        date
 * @param {String} pdfData.items.customer    customer
 * @param {String} pdfData.items.customerID  customerID
 * @param {String} pdfData.items.doctor      doctor
 * @param {String} pdfData.items.license     license
 * @param {String} pdfData.items.stockIn     stockIn
 * @param {String} pdfData.items.stockOut    stockOut
 *
 * @returns {Promise}
 */
const getPdfForCDrugs = ({
  customID,
  name,
  license,
  lot,
  purchaseDateTime,
  items,
}) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {
    customID,
    name,
    license,
    lot,
    purchaseDateTime,
    items,
  };
  return getPdf(customerID, "controlledDrug", data);
};

const getPdf = (customerID, type, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/pdf/${type}`,
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr, error) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得管制藥品造冊excel
 *
 * @param {String} drugID    drugID
 * @param {String} clinicSetting    clinic setting info
 *
 * @returns {Promise}
 */
const getCDrugsExcel = (drugID, data) => {
  let customerID = localStorage.getItem("CLINIC");
  return getExcel(customerID, `cdBook?drugID=${drugID}`, data);
};

/**
 * 獲得管制藥品造冊excel v2
 *
 * @param {String} drugID    drugID
 * @param {String} clinicSetting    clinic setting info
 *
 * @returns {Promise}
 */
const getCDrugsExcelV2 = (drugID, data) => {
  let customerID = localStorage.getItem("CLINIC");
  return getExcel(customerID, `cdBook/v2?drugID=${drugID}`, data);
};

const getExcel = (customerID, type, data) => {
  // let username = Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key);
  // let password = Crypto.decrypt(localStorage.getItem("LAST_PASSWORD"), key);
  let config = {
    headers: { Authorization: getAuthorization() },
    responseType: "blob",
  };

  let apiUrl = `${getApiServerHost()}/erp/${customerID}/excel/${type}`;
  return new Promise((resolve, reject) => {
    axios
      .post(apiUrl, data, config)
      .then((response) => {
        return resolve(response);
      })
      .catch((error) => {
        return reject(error.response);
      });
  });
};

const getCDrugsExcelData = (drugID) => {
  let customerID = localStorage.getItem("CLINIC");
  // let username = Crypto.decrypt(localStorage.getItem("LAST_USERNAME"), key);
  // let password = Crypto.decrypt(localStorage.getItem("LAST_PASSWORD"), key);
  let config = {
    headers: { Authorization: getAuthorization() },
  };

  let apiUrl = `${getApiServerHost()}/erp/${customerID}/excel/cdBook?drugID=${drugID}`;
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl, config)
      .then((response) => {
        return resolve(response);
      })
      .catch((error) => {
        return reject(error.response);
      });
  });
};

/**
 * 獲得Cost統計資料
 *
 * @returns {Promise}
 */
const getStatDataForStockCost = () => {
  let customerID = localStorage.getItem("CLINIC");
  return getStatData(customerID, "stockCost", {});
};

/**
 * 獲得Purchase統計資料
 *
 * @param {TimeStamp} startDate  startDate
 * @param {TimeStamp} [endDate]  endDate
 *
 * @returns {Promise}
 */
const getStatDataForPurchaseStatus = ({ startDate, endDate }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  return getStatData(customerID, "purchaseStatus", data);
};

/**
 * 獲得Sell統計資料
 *
 * @param {TimeStamp} startDate  startDate
 * @param {TimeStamp} [endDate]  endDate
 *
 * @returns {Promise}
 */
const getStatDataForSellStatus = ({ startDate, endDate }, staffID) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  if (staffID !== null) {
    data["staffID"] = staffID;
  }
  return getStatData(customerID, "sellStatus", data);
};

/**
 * 獲得Staff Sell資料
 *
 * @param {TimeStamp} startDate  startDate
 * @param {TimeStamp} [endDate]  endDate
 *
 * @returns {Promise}
 */
const getStaffSellStatus = ({ startDate, endDate }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  return getStatData(customerID, "staffSellStatus", data);
};

/**
 * 獲得Service統計資料
 *
 * @param {TimeStamp} startDate  startDate
 * @param {TimeStamp} [endDate]  endDate
 * @param {String}    staffID    staffID
 *
 * @returns {Promise}
 */
const getStatDataForServiceStatus = ({ startDate, endDate }, staffID) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  if (staffID !== null) {
    data["staffID"] = staffID;
  }
  return getStatData(customerID, "serviceStatus", data);
};

/**
 * 獲得staff service統計資料
 *
 * @param {TimeStamp} startDate  startDate
 * @param {TimeStamp} [endDate]  endDate
 *
 * @returns {Promise}
 */
const getStatDataForStaffServiceStatus = ({ startDate, endDate }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  return getStatData(customerID, "staffServiceStatus", data);
};

/**
 * 獲得統計資料for檔案
 *
 * @param {TimeStamp} startDate  startDate
 * @param {TimeStamp} [endDate]  endDate
 *
 * @returns {Promise}
 */
const getStatFileData = ({ startDate, endDate }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  return getStatData(customerID, "statFile", data);
};

const getStatFile = (data) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/statFile`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr, error) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

const getStatFileLink = () => {
  let customerID = localStorage.getItem("CLINIC");
  return `${getApiServerHost()}/erp/${customerID}/statFile`;
};

const getStatData = (customerID, type, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/stat/${type}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr, error) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得Stock Cost趨勢資料
 *
 * @param {TimeStamp} startDate  startDate
 * @param {TimeStamp} [endDate]  endDate
 *
 * @returns {Promise}
 */
const getStockCostTrend = ({ startDate, endDate }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  return getTrendData(customerID, "stockCost", data);
};

/**
 * 獲得Sell Status趨勢資料
 *
 * @param {TimeStamp} startDate  startDate
 * @param {TimeStamp} [endDate]  endDate
 *
 * @returns {Promise}
 */
const getSellStatusTrend = ({ startDate, endDate }) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  return getTrendData(customerID, "sellStatus", data);
};

/**
 * 獲得All趨勢資料
 *
 * @param {TimeStamp} startDate  startDate
 * @param {TimeStamp} [endDate]  endDate
 * @param {String}    staffID    staffID
 *
 * @returns {Promise}
 */
const getAllTrend = ({ startDate, endDate }, staffID) => {
  let customerID = localStorage.getItem("CLINIC");
  let data = {};
  if (startDate !== null) {
    data["startDate"] = startDate;
  }
  if (endDate !== null) {
    data["endDate"] = endDate;
  }
  if (staffID !== null) {
    data["staffID"] = staffID;
  }
  return getTrendData(customerID, "all", data);
};

const getTrendData = (customerID, type, data) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/trend/${type}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr, error) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得全部儀器列表
 *
 * @returns {Promise}
 */
const getDeviceList = () => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/device/getDeviceList`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得全部儀器列表
 *
 * @param {String} deviceID  deviceID
 *
 * @returns {Promise}
 */
const getDevice = (deviceID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/device/${deviceID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新儀器標準值取得方法
 *
 * @param {String} deviceID  deviceID
 * @param {Number} standard  standard(0 or 1)
 *
 * @returns {Promise}
 */
const updateDeviceStandard = (deviceID, standard) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/device/${deviceID}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ standard }),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得儀器全部標準值
 *
 * @param {String} deviceID  deviceID
 *
 * @returns {Promise}
 */
const getStandSetByDevice = (deviceID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/device/${deviceID}/getStandardList`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得全部預設標準值
 *
 * @returns {Promise}
 */
const getDefaultStandardSetList = () => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/device/getDefaultSetList`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得寵物適合的標準值
 *
 * @param {Json}   petInfo          petInfo
 * @param {String} petInfo.kind     pet kind without /kind/
 * @param {String} petInfo.breed    pet breed without /breed/kind/
 * @param {Number} petInfo.sexual   1:male, 2:female
 * @param {Number} petInfo.age      pet age
 * @param {Array}  devices          deviceID array
 *
 * @returns {Promise}
 */
const getFittingStandardSet = ({ petInfo, devices }) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/standardSet/getFittingSetByPet`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ petInfo, devices }),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 建立標準值組
 *
 * @param {Number} standardInfo  standard info (includes standard values)
 *
 * @returns {Promise}
 */
const createStandSet = (standardInfo) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/standardSet`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(standardInfo),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 取得標準值組
 *
 * @param {String} standardID  standardID
 *
 * @returns {Promise}
 */
const getStandSet = (standardID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/standardSet/${standardID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新標準值組
 *
 * @param {String} standardID  standardID
 * @param {Number} standardInfo  standard info (includes standard values)
 *
 * @returns {Promise}
 */
const updateStandSet = (standardID, standardInfo) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/standardSet/${standardID}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(standardInfo),
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除標準值組
 *
 * @param {String} standardID  standardID
 *
 * @returns {Promise}
 */
const deleteStandSet = (standardID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/standardSet/${standardID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        // var username = Crypto.decrypt(
        //   localStorage.getItem("LAST_USERNAME"),
        //   key
        // );
        // var password = Crypto.decrypt(
        //   localStorage.getItem("LAST_PASSWORD"),
        //   key
        // );
        // xhr.setRequestHeader(
        //   "Authorization",
        //   "Basic " + btoa(username + ":" + password)
        // );
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 新增檔案資訊
 * @param {Json}   fileData
 * @param {String} fileData._id          _id
 * @param {String} fileData.type         type
 * @param {String} fileData.name         name
 * @param {String} fileData.description  description
 * @param {String} fileData.formID       formID
 *
 * @returns {Promise}
 */
const createFormFile = (fileData) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/formFile`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(fileData),
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得檔案資訊
 * @param {String} fileID      fileID
 *
 * @returns {Promise}
 */
const getFormFile = (fileID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      url: `${getApiServerHost()}/erp/${customerID}/formFile/${fileID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        let prefixPath = prefix.getFormImagePrefixPath(
          getSDKServerHost(),
          customerID,
          Crypto.encrypt(fileID, key)
        );
        xhr._id = `${prefixPath}/${xhr._id}`;
        xhr.desc = xhr.description;
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 更新檔案資訊
 * @param {Json}   fileData
 * @param {String} fileData._id          _id
 * @param {String} fileData.type         type
 * @param {String} fileData.name         name
 * @param {String} fileData.description  description
 *
 * @returns {Promise}
 */
const updateFormFile = (fileData) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "PUT",
      url: `${getApiServerHost()}/erp/${customerID}/formFile/${fileData._id}`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(fileData),
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 刪除檔案資訊
 * @param {String} fileID      fileID
 *
 * @returns {Promise}
 */
const deleteFormFile = (fileID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "DELETE",
      url: `${getApiServerHost()}/erp/${customerID}/formFile/${fileID}`,
      dataType: "json",
      contentType: "application/json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 獲得Form全部檔案資訊
 *
 * @param {String} formID      formID
 *
 * @returns {Promise}
 */
const getFormFileByFormID = (formID) => {
  let customerID = localStorage.getItem("CLINIC");
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/formFile/getList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ formID }),
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        let prefixPath = prefix.getFormImagePrefixPath(
          getSDKServerHost(),
          customerID,
          Crypto.encrypt(formID, key)
        );
        for (let img of xhr) {
          img._id = `${prefixPath}/${img._id}`;
          img.desc = img.description;
        }
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

const getFormFileFromPhone = (customerID, formID) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/formFile/getList`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ formID }),
      beforeSend: (xhr) => {
        xhr.setRequestHeader(
          "Authorization",
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXN0ZW1Sb2xlIjoic3VkbyIsImVtdWxhdG9yIjp0cnVlLCJzb3VyY2VFbWFpbCI6InN1ZG9AZm94Y29ubi5jb20iLCJzb3VyY2VOYW1lIjoic3VkbyIsImVtYWlsIjoibHVmZkBob3RtYWlsLmNvbSIsIm5hbWUiOiLpra_lpKsiLCJjbGluaWNSb2xlcyI6W3siY2xpbmljIjoiMTY1MDg2NTU3MSIsImNsaW5pY05hbWUiOiLojYnluL3mtbfos4rlnJgiLCJzdGFmZklEIjoiL3N0YWZmL2x1ZmZAaG90bWFpbC5jb20iLCJyb2xlSUQiOiJhZG1pbiIsInJvbGVOYW1lIjoi6Zmi6ZW3IiwicGVybWlzc2lvbnMiOltdfV0sImFsbGlhbmNlIjoiIiwiaWF0IjoxNjg5MzI3ODk1fQ.qm2ZaR9ggmGfiYIWbkrOdyZX2di37yPLP9PqX-aHY3E"
        );
      },
      success: (xhr) => {
        let prefixPath = prefix.getFormImagePrefixPath(
          getSDKServerHost(),
          customerID,
          Crypto.encrypt(formID, key)
        );
        for (let img of xhr) {
          img._id = `${prefixPath}/${img._id}`;
          img.desc = img.description;
        }
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

/**
 * 儲存IP紀錄
 *
 * @param {String} ip  standardID
 *
 * @returns {Promise}
 */
const saveUserIP = (active) => {
  let customerID = localStorage.getItem("CLINIC");
  let userIP = localStorage.getItem("LOCAL_IP") || "";
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      url: `${getApiServerHost()}/erp/${customerID}/saveIP`,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify({ userIP, active }),
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", getAuthorization());
      },
      success: (xhr) => {
        resolve({ code: 100000, message: RTN_MSG["100000"], result: xhr });
      },
      error: (xhr) => {
        reject({ code: 900000, message: RTN_MSG["900000"], result: xhr });
      },
    });
  });
};

//https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

const RTN_MSG = {
  100000: "成功",
  900000: "發生錯誤",
  100100: "登入成功",
  100101: "帳號密碼錯誤",
  100102: "沒有可以驗證的服務，請檢查網路連線",
  100103: "未登入",
  100104: "需要網路連線",
  100105: "缺少必要參數",
  100106: "登入帳號沒有可用的診所",
  100107: "登入使用者資料錯誤",
  100108: "無存取該資料庫的權限",
  100404: "找不到可以操作的資源",
  200001: "飼主 UserID 有誤",
  200002: "缺少查詢品種條件",
  200003: "寵物 petID 有誤",
  200004: "飼主電話重複",
  200005: "使用者已經註冊, Email 重複",
  200006: "註冊失敗，員工數已達上限",
};

export default {
  ORDER_PROCESS: ORDER_PROCESS,
  ORDER_COMPLETE: ORDER_COMPLETE,
  ORDER_PLACE: ORDER_PLACE,

  switchCustomer: switchCustomer,
  getApiServerHost: getApiServerHost,
  setApiServerHost: setApiServerHost,

  createSupplier: createSupplier,
  getSupplierData: getSupplierData,
  updateSupplierData: updateSupplierData,
  deleteSupplier: deleteSupplier,
  getSupplierList: getSupplierList,

  createProd: createProd,
  getMultiProdData: getMultiProdData,
  getProdData: getProdData,
  getProdIdByBarcode: getProdIdByBarcode,
  updateProdData: updateProdData,
  updateLotData: updateLotData,
  deleteProd: deleteProd,
  getProdList: getProdList,
  getProdInfoList: getProdInfoList,
  getCDInfoList: getCDInfoList,
  getCDSimpleInfoByIDS: getCDSimpleInfoByIDS,
  getProdStockList: getProdStockList,
  getStockByIds: getStockByIds,

  createPackage: createPackage,
  getPackageList: getPackageList,
  getPackage: getPackage,
  updatePackage: updatePackage,
  deletePackage: deletePackage,

  createProdLevel: createProdLevel,
  getProdLevelList: getProdLevelList,
  getProdLevel: getProdLevel,
  updateProdLevel: updateProdLevel,
  updateMultiProd: updateMultiProd,
  deleteProdLevel: deleteProdLevel,

  getExamList: getExamList,
  getVendorList: getVendorList,

  createService: createService,
  getServiceList: getServiceList,
  getService: getService,
  updateService: updateService,
  updateServiceSequence: updateServiceSequence,
  deleteService: deleteService,
  getExamOrders: getExamOrders,

  createFormForPayment: createFormForPayment,
  createFormForPurchase: createFormForPurchase,
  createFormForOrder: createFormForOrder,
  createFormForSell: createFormForSell,
  createFormForCheck: createFormForCheck,
  createFormForReturn: createFormForReturn,
  getFormDataForPurchase: getFormDataForPurchase,
  getFormDataForOrder: getFormDataForOrder,
  getFormDataForSell: getFormDataForSell,
  getFormDataForCheck: getFormDataForCheck,
  updateFormDataForPayment: updateFormDataForPayment,
  updateFormDataForPurchase: updateFormDataForPurchase,
  updateFormDataForOrder: updateFormDataForOrder,
  updateFormDataForSell: updateFormDataForSell,
  updateFormDataForCheck: updateFormDataForCheck,
  updateFormDataForReturn: updateFormDataForReturn,
  deleteFormForPayment: deleteFormForPayment,
  deleteFormForPurchase: deleteFormForPurchase,
  deleteFormForOrder: deleteFormForOrder,
  deleteFormForSell: deleteFormForSell,
  deleteFormForCheck: deleteFormForCheck,
  deleteFormForReturn: deleteFormForReturn,
  getFormListForPurchase: getFormListForPurchase,
  getFormListForSell: getFormListForSell,
  getFormListForCheck: getFormListForCheck,

  createSellFormByRecord: createSellFormByRecord,
  createSellFormByInHospital: createSellFormByInHospital,
  deleteSellForm: deleteSellForm,
  // createItemForPurchase: createItemForPurchase,
  // createItemForSell: createItemForSell,
  // createItemForCheck: createItemForCheck,
  // getItemDataForPurchase: getItemDataForPurchase,
  // getItemDataForSell: getItemDataForSell,
  // getItemDataForCheck: getItemDataForCheck,
  // updateItemDataForPurchase: updateItemDataForPurchase,
  // updateItemDataForSell: updateItemDataForSell,
  // updateItemDataForCheck: updateItemDataForCheck,
  // deleteItemForPurchase: deleteItemForPurchase,
  // deleteItemForSell: deleteItemForSell,
  // deleteItemForCheck: deleteItemForCheck,
  // getItemListForPurchase: getItemListForPurchase,
  // getItemListForSell: getItemListForSell,
  // getItemListForCheck: getItemListForCheck,
  getFormInfoListForPayment: getFormInfoListForPayment,
  getFormInfoListForPurchase: getFormInfoListForPurchase,
  getFormInfoListForOrder: getFormInfoListForOrder,
  getFormInfoListForSell: getFormInfoListForSell,
  getFormInfoListForCheck: getFormInfoListForCheck,
  getCountForSuppliers: getCountForSuppliers,

  createCustomerSettingForType: createCustomerSettingForType,
  createCustomerSettingForUnit: createCustomerSettingForUnit,
  createCustomerSettingForServiceClass: createCustomerSettingForServiceClass,
  createCustomerSettingForServiceType: createCustomerSettingForServiceType,
  getCustomerSettingForType: getCustomerSettingForType,
  getCustomerSettingForUnit: getCustomerSettingForUnit,
  getCustomerSettingForAll: getCustomerSettingForAll,
  getCustomerSettingByType: getCustomerSettingByType,
  updateCustomerSettingForType: updateCustomerSettingForType,
  updateCustomerSettingForUnit: updateCustomerSettingForUnit,
  updateServiceClassSequence: updateServiceClassSequence,
  updateServiceTypeSequence: updateServiceTypeSequence,
  updateCustomerSettingSequence: updateCustomerSettingSequence,
  deleteCustomerSettingForType: deleteCustomerSettingForType,
  deleteCustomerSettingForUnit: deleteCustomerSettingForUnit,
  deleteCustomerSettingForServiceClass: deleteCustomerSettingForServiceClass,
  deleteCustomerSettingForServiceType: deleteCustomerSettingForServiceType,

  getPdfForOrder: getPdfForOrder,
  getPdfForCheck: getPdfForCheck,
  getPdfForCDrugs: getPdfForCDrugs,
  getCDrugsExcel: getCDrugsExcel,
  getCDrugsExcelV2: getCDrugsExcelV2,
  getCDrugsExcelData: getCDrugsExcelData,
  getStatDataForStockCost: getStatDataForStockCost,
  getStatDataForPurchaseStatus: getStatDataForPurchaseStatus,
  getStatDataForSellStatus: getStatDataForSellStatus,
  getStaffSellStatus: getStaffSellStatus,
  getStatDataForServiceStatus: getStatDataForServiceStatus,
  getStatDataForStaffServiceStatus: getStatDataForStaffServiceStatus,
  getStatFileData: getStatFileData,
  getStatFile: getStatFile,
  getStatFileLink: getStatFileLink,

  getStockCostTrend: getStockCostTrend,
  getSellStatusTrend: getSellStatusTrend,
  getAllTrend: getAllTrend,

  getDeviceList: getDeviceList,
  getDevice: getDevice,
  updateDeviceStandard: updateDeviceStandard,
  getStandSetByDevice: getStandSetByDevice,
  getDefaultStandardSetList: getDefaultStandardSetList,
  getFittingStandardSet: getFittingStandardSet,
  createStandSet: createStandSet,
  getStandSet: getStandSet,
  updateStandSet: updateStandSet,
  deleteStandSet: deleteStandSet,

  createFormFile: createFormFile,
  getFormFile: getFormFile,
  updateFormFile: updateFormFile,
  deleteFormFile: deleteFormFile,
  getFormFileByFormID: getFormFileByFormID,
  getFormFileFromPhone: getFormFileFromPhone,

  saveUserIP: saveUserIP,
  b64toBlob: b64toBlob,
};
